import { FC } from 'react';
// component
import StaffComponent from 'components/main//Staff';

const Staff: FC = () => <StaffComponent />;

export default Staff;
